import { createSlice } from "@reduxjs/toolkit";

export const residentsArraySlice = createSlice({
    name:"residentsArray",
    initialState:{
        orign_residents_array:[],
        leave_hospital_array:[]
    },
    reducers:{
        ADD_RESIDENTS_ARRAY:(state, action)=>{
            if(action.payload!==null){
                let acc = localStorage.getItem("currentAccount") || sessionStorage.getItem("currentAccount")
                let userInfo = JSON.parse(localStorage.getItem(acc) || sessionStorage.getItem(acc)) || {}
                let id = userInfo.id
                let role = userInfo.role
                let _arr = []
                let _leave_arr = []
                if(role === "superdoctor" || role==="admin"){
                    _arr = action.payload.filter(e => e.leave_hospital!==1);
                    _leave_arr = action.payload.filter(e => e.leave_hospital===1);
                }else{
                    let _tmp_split_arr = []
                    action.payload.forEach(element => {
                        if(element.user_id!=="" && element.user_id!==null){
                            element.user_id.split(",").forEach(e=>{
                                if(Number(e)===Number(id)){ _tmp_split_arr.push(element) }
                            })
                            _arr = _tmp_split_arr.filter(e => e.leave_hospital!==1);
                            _leave_arr = _tmp_split_arr.filter(e => e.leave_hospital===1);
                        }
                    })
                }
                state.orign_residents_array=_arr
                state.leave_hospital_array=_leave_arr
            }
        },
        CLEAR_RESIDENTS_ARRAY:(state)=>{
            state.orign_residents_array = []
            state.leave_hospital_array = []
        }
    },
})

export const {
    ADD_RESIDENTS_ARRAY,
    CLEAR_RESIDENTS_ARRAY
} = residentsArraySlice.actions

export default residentsArraySlice.reducer